const CALL_SLUGS = new Set(['phone_manual', 'phone_ai', 'phone_aircall']);

/**
 * Returns true if the activity belongs to a phone/call channel type.
 * @param {object} activity - Activity with channelTypeId
 * @param {Array}  channelTypes - List of channel type objects with id & slug
 */
export function isCallActivity(activity, channelTypes) {
	if (!activity?.channelTypeId || !channelTypes?.length) return false;
	const ch = channelTypes.find((c) => c.id === activity.channelTypeId);
	return ch ? CALL_SLUGS.has(ch.slug) : false;
}
